import { makeSvgIcon } from '../makeSvgIcon'

export const sun = makeSvgIcon(
  <path d="M12 1L13.9929 4.56237L17.5 2.47372L17.4447 6.55528L21.5263 6.5L19.4376 10.0071L23 12L19.4376 13.9929L21.5263 17.5L17.4447 17.4447L17.5 21.5263L13.9929 19.4376L12 23L10.0071 19.4376L6.5 21.5263L6.55528 17.4447L2.47372 17.5L4.56237 13.9929L1 12L4.56237 10.0071L2.47372 6.5L6.55528 6.55528L6.5 2.47372L10.0071 4.56237L12 1Z" />
)
